/*@ngInject*/
export default ['moment', function(moment)  {
    return {
      en: {
        'Today': [moment().startOf('day'), moment().endOf('day')],
        'Yesterday': [moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days')],
        'Last 7 Days': [moment().startOf('day').subtract(6, 'days'), moment().endOf('day')],
        'Last 30 Days': [moment().startOf('day').subtract(29, 'days'), moment().endOf('day')],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      es: {
        'Hoy': [moment().startOf('day'), moment().endOf('day')],
        'Ayer': [moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days')],
        'Últimos 7 días': [moment().startOf('day').subtract(6, 'days'), moment().endOf('day')],
        'Últimos 30 días': [moment().startOf('day').subtract(29, 'days'), moment().endOf('day')],
        'Este mes': [moment().startOf('month'), moment().endOf('month')],
        'El mes pasado': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      pl: {
        'Dzisiaj': [moment().startOf('day'), moment().endOf('day')],
        'Wczoraj': [moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days')],
        'Ostatnie 7 dni': [moment().startOf('day').subtract(6, 'days'), moment().endOf('day')],
        'Ostatnie 30 dni': [moment().startOf('day').subtract(29, 'days'), moment().endOf('day')],
        'Bieżący miesiąc': [moment().startOf('month'), moment().endOf('month')],
        'Poprzedni miesiąc': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      }
    }
}];
